import { render, staticRenderFns } from "./ChatEventsTeaserBox.vue?vue&type=template&id=178b1c4c&scoped=true&"
import script from "./ChatEventsTeaserBox.vue?vue&type=script&lang=js&"
export * from "./ChatEventsTeaserBox.vue?vue&type=script&lang=js&"
import style0 from "./ChatEventsTeaserBox.vue?vue&type=style&index=0&id=178b1c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178b1c4c",
  null
  
)

export default component.exports